module.exports = __webpack_public_path__ + "static/RingSavvyTagline-White-25445aafdc1bea2f0a09738458b42cf3.svg";